export default __webpack_public_path__ + "static/media/register.80b74a89.png";